@if (horizontalMenu) {
  <div class="navbar-header d-xl-block d-none">
    <!-- Navbar brand -->
    <ul class="nav navbar-nav flex-row">
      <li class="nav-item">
        <a class="navbar-brand" [routerLink]="['/']">
          <span class="brand-logo">
            <img
              src="assets/images/icons/econnect-logo.svg"
              alt="brand-logo"
              width="36"
              />
            </span>
          </a>
        </li>
      </ul>
      <!--/ Navbar brand -->
    </div>
  }

  <div class="navbar-container d-flex content">
    <div class="bookmark-wrapper d-flex align-items-center">
      <!-- Menu Toggler | Menu icon will be hidden in case of layout without menu -->
      @if (!coreConfig.layout.menu.hidden) {
        <ul class="nav navbar-nav d-xl-none">
          <li class="nav-item">
            <a class="nav-link menu-toggle" (click)="toggleSidebar('menu')">
              <span [data-feather]="'menu'" [class]="'ficon'"></span>
            </a>
          </li>
        </ul>
      }
      <!--/ Menu Toggler -->
    </div>
    <ul class="nav navbar-nav align-items-center me-auto">
      <!-- User -->
      <li class="nav-item dropdown-user">
        <a
          class="nav-link dropdown-toggle dropdown-user-link"
          aria-haspopup="true"
          aria-expanded="false"
          >
          @if (this.currentWorker) {
            <span class="avatar me-1">
              <app-api-image
                class="round max-height-it-can"
                [imgClass]="'machine-img'"
                [src]="currentWorker.avatarUrl"
                [height]="40"
                [width]="40"
                [sourceSize]="'&size=40'"
                [defaultSource]="'assets/images/icons/default-user.svg'"
              ></app-api-image>
            </span>
            <div class="user-nav d-sm-flex d-none">
              <span class="user-status text-muted mb-small">
                {{ "GENERAL.USER" | translate }}:
              </span>
              <span class="user-name fw-bolder m-0 text-white">
                {{ this.currentWorker.name }}
              </span>
            </div>
          }
        </a>
      </li>
      @if (!masterSlaveMode && !isConfiguration) {
        <li class="nav-item">
          <a
            class="me-1"
            (click)="planifications($event)"
            href="javascript:void(0);"
            rel="noopener noreferrer"
            placement="left"
            ngbTooltip="{{ 'GENERAL.PLANIFICATION' | translate }}"
            >
            <i
              class="econnect-icon feather-48"
          style="
            background-image: url('assets/images/icons/header-ico-agenda.svg');
          "
            ></i>
          </a>
        </li>
      }
      @if (
        !isConfiguration &&
        (!masterSlaveMode || (masterSlaveMode && !slaveMachine))
        ) {
        <li
          class="nav-item"
          >
          <a
            class="me-1"
            (click)="logout($event)"
            href="javascript:void(0);"
            rel="noopener noreferrer"
            placement="left"
            ngbTooltip="Logout"
            >
            <i
              class="econnect-icon feather-48"
          style="
            background-image: url('assets/images/icons/header-ico-exit.svg');
          "
            ></i>
          </a>
        </li>
      }
      @if (!masterSlaveMode && !isConfiguration) {
        <li
          class="nav-item"
          [class.separator-right]="isMaintenance"
          >
          <a
            class="mx-1"
            (click)="machines($event)"
            href="javascript:void(0);"
            rel="noopener noreferrer"
            placement="left"
            ngbTooltip="{{ 'GENERAL.MACHINES' | translate }}"
            >
            <i
              class="econnect-icon feather-48"
          style="
            background-image: url('assets/images/icons/header-ico-fabrica.svg');
          "
            ></i>
          </a>
        </li>
      }
      @if (!masterSlaveMode && !isConfiguration && isMaintenance) {
        <li
          class="nav-item"
          >
          <a
            class="mx-1"
            [href]="urlMaintenance"
            placement="right"
            ngbTooltip="{{ 'GENERAL.MAINTENANCE' | translate }}"
            >
            <i
              class="econnect-icon feather-48"
              style="background-image: url('assets/images/icons/Manteniment.svg')"
            ></i>
          </a>
        </li>
      }
      @if (isConfiguration) {
        <li class="nav-item my-auto">
          <a
            (click)="goBack()"
            href="javascript:void(0);"
            rel="noopener noreferrer"
            placement="right"
            ngbTooltip="{{ 'GENERAL.BACK' | translate }}"
            >
            <i
              class="econnect-icon feather-48"
          style="
            background-image: url('assets/images/icons/header-ico-back.svg');
          "
            ></i>
          </a>
        </li>
      }
      <!--/ Toggle skin -->
    </ul>
    <ul class="nav navbar-nav align-items-end ms-auto">
      <li class="nav-item" style="margin-right: 1rem">
        <span class="fw-bolder date">
          {{ currentTime | date : "dd.MM.yyyy HH:mm:ss" }}
        </span>
      </li>
      <li class="nav-item">
        <!-- App Branding -->
        <a class="navbar-brand">
          <!-- Logo -->
          <div class="brand-logo">
            <!-- [attr.src]="coreConfig.app.appLogoImage" -->
            <img
              class="brand-img cursor-default"
              [attr.src]="'assets/images/icons/econnect-logo.svg'"
              />
            </div>
          </a>
        </li>
        @if (!isConfiguration) {
          <li class="nav-item my-auto">
            <a
              (click)="configuration($event)"
              href="javascript:void(0);"
              rel="noopener noreferrer"
              placement="left"
              ngbTooltip="{{ 'GENERAL.CONFIGURATION' | translate }}"
              >
              <i
                class="econnect-icon feather-48"
          style="
            background-image: url('assets/images/icons/header-ico-settings.svg');
          "
              ></i>
            </a>
          </li>
        }
        <!--/ Toggle skin -->
      </ul>
    </div>
